import { render, staticRenderFns } from "./MonthlyEPFMaybank.vue?vue&type=template&id=e6448b50&scoped=true"
import script from "./MonthlyEPFMaybank.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFMaybank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6448b50",
  null
  
)

export default component.exports